import { render } from "./Tasks.vue?vue&type=template&id=8dcc5f00&scoped=true&ts=true"
import script from "./Tasks.vue?vue&type=script&lang=ts"
export * from "./Tasks.vue?vue&type=script&lang=ts"

import "./Tasks.vue?vue&type=style&index=0&id=8dcc5f00&scoped=true&lang=scss"

import exportComponent from "D:\\Onix_View_Internship\\website-redesign-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dcc5f00"]])

export default __exports__